import { gsap } from "gsap";
import barba from "@barba/core";
import Alpine from "alpinejs";

Alpine.data("teaserItems", () => ({
  init() {
    const teasers = this.$root.querySelectorAll('.c-teaser-items__teaser');
    const leaveAnimation = () => {
      gsap.to(Array.from(teasers), {
        y: 100,
        opacity: 0,
        duration: 0.3,
        stagger: {
          each: 0.1,
        },
      });
    };
    barba.hooks.beforeLeave(leaveAnimation);
  },
  handleMouseEnter(event) {
    const video = event.target?.querySelector("video");

    if (video) {
      video.pause();
      video.currentTime = 0;
      video.play();
    }
  },
}));
